import PropTypes from "prop-types";
import ReactApexChart from "react-apexcharts";
// @mui
import { Card, CardHeader, Box, Grid } from "@mui/material";
// components
import { useChart } from "./chart";
import { useEffect, useState, useCallback } from "react";

import ClipLoader from "react-spinners/ClipLoader";
import AppWidgetSummary from "./AppWidgetSummary";
import { LikeOutlined, MessageOutlined, StarOutlined } from "@ant-design/icons";
import { Avatar, List, Skeleton, Switch } from "antd";
// ----------------------------------------------------------------------
var sum1 = 0;

SetIncomByDay.propTypes = {
  title: PropTypes.string,
  subheader: PropTypes.string,
  chartData: PropTypes.array.isRequired,
  chartLabels: PropTypes.arrayOf(PropTypes.string).isRequired,
};
export default function SetIncomByDay({
  title,
  subheader,
  chartLabels,
  chartData,
  ...other
}) {
  console.log(chartData);
  const [data, setData] = useState(null);
  const [array, setArray] = useState([]);
  const [O2rrevenue, setO2rRevenue] = useState([]);
  const [SumDaily, setSumDaily] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [revenue, setrevenue] = useState([]);

  const chartLabels2 = [
    "00:00",
    "01:00",
    "02:00",
    "03:00",
    "04:00",
    "05:00",
    "06:00",
    "07:00",
    "08:00",
    "09:00",
    "10:00",
    "11:00",
    "12:00",
    "13:00",
    "14:00",
    "15:00",
    "16:00",
    "17:00",
    "18:00",
    "19:00",
    "20:00",
    "21:00",
    "22:00",
    "23:00",
  ];

  const chartData1 = [
    {
      name: "O2R",
      type: "line",
      fill: "solid",
      data: revenue,
    },
  ];
  // console.log(chartData1)
  const chartOptions = useChart({
    plotOptions: { bar: { columnWidth: "30%" } },
    fill: { type: chartData.map((i) => i.fill) },
    labels: chartLabels2,
    xaxis: { type: "time" },
    tooltip: {
      shared: true,
      intersect: false,
      y: {
        formatter: (y) => {
          if (typeof y !== "undefined") {
            return `${y
              .toFixed(2)
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")} $`;
          }
          return y;
        },
      },
    },
  });

  return (
    <>
      {!isLoading ? (
        <>
          <Skeleton active avatar>
            <List.Item.Meta
              avatar={<Avatar src={""} />}
              title={<a href={""}>{""}</a>}
              description={""}
            />
            {""}
          </Skeleton>
        </>
      ) : (
        <>
          <Card {...other}>
            <CardHeader title={title} subheader={subheader} thesum11={sum1} />

            <Box sx={{ p: 3, pb: 1 }} dir="ltr">
              <h5>NetIncome by Dollar $</h5>
              <ReactApexChart
                type="line"
                series={chartData}
                options={chartOptions}
                height={650}
              />
            </Box>
            <h5
              style={{
                justifyContent: "center",
                alignItems: "center",
                display: "flex",
                color: "black",
              }}
            >
              Hours
            </h5>
          </Card>
        </>
      )}
    </>
  );
}

export const SetIncomByDay7 = ({ chartData }) => {
  const [data, setData] = useState(null);
  const [array, setArray] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [SumDaily, setSumDaily] = useState([]);
  const [loading, setLoading] = useState(true);

  return (
    <div>
      {" "}
      {!isLoading ? (
        <>
          <Skeleton active avatar>
            <List.Item.Meta
              avatar={<Avatar src={""} />}
              title={<a href={""}>{""}</a>}
              description={""}
            />
            {""}
          </Skeleton>
        </>
      ) : (
        <>
          <Grid>
            <Grid item>
              <AppWidgetSummary
                title="Daily Net Income Projection"
                total={`${chartData
                  .toFixed(3)
                  .toString()
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",")} $`}
                icon={"ant-design:android-filled"}
              />
            </Grid>{" "}
          </Grid>{" "}
          <br></br>
        </>
      )}
    </div>
  );
};
